import { render, staticRenderFns } from "./ProjectPopup.vue?vue&type=template&id=2efd7223&"
import script from "./ProjectPopup.vue?vue&type=script&lang=js&"
export * from "./ProjectPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports